import { render, staticRenderFns } from "./registerForDownload.vue?vue&type=template&id=15d5f3d6&scoped=true"
import script from "./registerForDownload.vue?vue&type=script&lang=js"
export * from "./registerForDownload.vue?vue&type=script&lang=js"
import style0 from "./registerForDownload.vue?vue&type=style&index=0&id=15d5f3d6&prod&lang=css"
import style1 from "./registerForDownload.vue?vue&type=style&index=1&id=15d5f3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5f3d6",
  null
  
)

export default component.exports